<template>
  <div id="app">
    <router-view v-show="!maintenanceMode" />
    <div v-if="maintenanceMode" class="app-maintenance-page">
      <el-empty description="平台维护中，暂时无法提供服务，请稍后重试或联系管理员">
        <el-button type="primary" @click="handleMaintenanceRetry">
          重试
        </el-button>
      </el-empty>
    </div>
  </div>
</template>

<script>
import { maintenanceStore } from '@/utils/maintenanceStore';

export default {
  name: 'App',
  computed: {
    maintenanceMode() {
      return maintenanceStore.active;
    }
  },
  methods: {
    handleMaintenanceRetry() {
      maintenanceStore.active = false;
      this.$router.push({ path: '/login' }).catch(() => {});
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif;
  background-color: #f5f7fa;
  font-weight: normal;
}

/* 全局去掉字体加粗 */
* {
  font-weight: normal !important;
}

h1, h2, h3, h4, h5, h6,
.el-dialog__title,
.el-form-item__label,
.el-table th,
.el-button {
  font-weight: normal !important;
}

#app {
  width: 100%;
  height: 100vh;
}

.app-maintenance-page {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  min-height: 100vh;
}

/* 所有可点击元素显示小手指针 */
button,
a,
.el-button,
.el-menu-item,
.el-tag,
.el-link,
.el-card[class*="hover"],
.el-table__row,
.el-pagination button,
.el-pagination .number,
.el-select,
.el-input__icon,
.el-checkbox,
.el-radio,
.el-switch,
[role="button"],
[onclick],
[class*="clickable"] {
  cursor: pointer;
}

.el-table .el-button--text {
  cursor: pointer;
}

/* ========== 全局表格样式优化 - 撑满页面 ========== */
.el-card {
  border: none;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.el-card__body {
  padding: 16px;
}

/* 日期/时间选择器：可用日期与时间的背景色 */
.el-date-table td.available {
  background-color: #ecf5ff;
}
.el-time-spinner__item:not(.disabled) {
  background-color: #ecf5ff;
}

/* el-tabs 当前选中的 tab 背景色 */
.el-tabs__item.is-active {
  background-color: #ecf5ff;
}

/* 校区信息下动态城市 tab 宽度（全局生效） */
.campus-city-tabs .el-tabs__item {
  width: 120px !important;
  min-width: 120px !important;
}

.table-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-card.el-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.table-card .el-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0;
  min-height: 0;
  overflow: hidden;
}

.table-card .el-table {
  flex: 1;
  height: 100% !important;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-card .el-table__body-wrapper {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

/* 表格美化 */
.el-table {
  border-radius: 8px;
  overflow: hidden;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.el-table::before {
  display: none;
}

.el-table th {
  background: #d9ecff !important;
  color: #303133;
  font-weight: normal;
  font-size: 13px;
  padding: 14px 0;
}

.el-table td {
  padding: 12px 0;
  font-size: 13px;
}

.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fafcff;
}

.el-table__body tr:hover > td {
  background-color: #f0f7ff !important;
}

/* 表格空数据提示垂直居中 */
.el-table__empty-block {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  width: 100% !important;
  height: 100% !important;
}

.el-table__empty-text {
  color: #909399;
  font-size: 14px;
  line-height: 1.5;
}

.table-card .el-table__empty-block {
  min-height: 300px;
}

/* 分页样式优化 */
.el-pagination {
  padding: 16px 0;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
}

/* 搜索区域优化 */
.search-area,
.search-card {
  margin-bottom: 12px;
}

.search-form .el-form-item {
  margin-bottom: 12px;
}

/* 按钮样式优化 */
.el-button--primary {
  background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
  border: none;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

.el-button--primary:hover {
  background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
}

.el-button--success {
  background: linear-gradient(135deg, #67C23A 0%, #85ce61 100%);
  border: none;
  box-shadow: 0 2px 8px rgba(103, 194, 58, 0.3);
}

.el-button--danger {
  background: linear-gradient(135deg, #F56C6C 0%, #f78989 100%);
  border: none;
  box-shadow: 0 2px 8px rgba(245, 108, 108, 0.3);
}

/* 对话框优化 */
.el-dialog__wrapper {
  overflow: hidden;
}

.el-dialog {
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  margin-top: 5vh !important;
  margin-bottom: 5vh !important;
}

.el-dialog__header {
  background: #a0cfff !important;
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
  flex-shrink: 0;
}

.el-dialog__title {
  font-size: 16px;
  font-weight: normal;
  color: #303133;
}

.el-dialog__body {
  padding: 24px 20px;
  flex: 1;
  overflow-y: auto;
  max-height: calc(90vh - 130px);
}

.el-dialog__footer {
  padding: 12px 20px 20px !important;
  border-top: 1px solid #ebeef5 !important;
  text-align: center !important;
  flex-shrink: 0;
}

/* 折叠面板全局样式 - 四角圆角 + 标题背景（body 前缀兼容 dialog append-to-body，!important 覆盖 Element 主题） */
body .el-collapse {
  border-radius: 8px !important;
  overflow: hidden !important;
  border: none !important;
}

body .el-collapse-item__header {
  background: #d9ecff !important;
  border-bottom: 1px solid #ebeef5 !important;
  font-size: 14px !important;
  padding-left: 12px !important;
}

body .el-collapse-item:first-child .el-collapse-item__header {
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
}

body .el-collapse-item:last-child .el-collapse-item__wrap {
  border-bottom-left-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}

body .el-collapse-item__wrap {
  border-bottom: none !important;
}

/* Tag 样式优化 */
.el-tag {
  border-radius: 4px;
  border: none;
  font-size: 12px;
}

.el-tag--success {
  background-color: #e8f8e8;
  color: #52c41a;
}

.el-tag--danger {
  background-color: #fff2f0;
  color: #f5222d;
}

.el-tag--warning {
  background-color: #fff7e6;
  color: #fa8c16;
}

.el-tag--info {
  background-color: #f5f5f5;
  color: #8c8c8c;
}

/* 输入框优化 */
.search-card .el-input,.el-select,.el-date-editor {
  width: 200px;
}


.el-input__inner {
  border-radius: 6px;
  transition: all 0.3s;
}

.el-input__inner:focus {
  border-color: #409EFF;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

 .el-select .el-input__inner {
  border-radius: 6px;
}

html body .el-range-editor span.el-range-separator{
    width:7% !important;
 }
 html body .el-date-table td.in-range div {
  background-color:#409eff;
 }
 html body .el-date-table td.in-range div:hover {
  background-color:#409eff;
  font-size: 16px;
 }
 html body .el-date-table td.in-range div {
  color:white;
  font-size: 13px;
 }
/* 日期选择器-周样式 */
html body .el-date-picker .el-date-table .current td.available div{
  background-color: #409eff;
}
html body .el-date-picker .el-date-table .el-date-table__row:hover div{
  background-color: #a5d0ff;
}
html body .el-date-picker .el-date-table .current td.available div span{
  color:white;
  font-size:14px;
  /* font-weight: bold !important; */
}
/* 滚动条美化 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 页面容器优化 - 填满剩余高度 */
.org-manage,
.staff-manage,
.student-manage,
.role-manage,
.dict-manage,
.log-manage {
  flex: 1 !important;
  display: flex !important;
  flex-direction: column !important;
  min-height: 0 !important;
  overflow: hidden !important;
}

/* 侧栏宽度与 el-aside 一致，供固定分页条 left 随折叠变化（Layout 根节点加 layout-aside-collapsed） */
.layout-watermark-root {
  --layout-aside-width: 200px;
}
.layout-watermark-root.layout-aside-collapsed {
  --layout-aside-width: 64px;
}

/* 分页器容器优化 */
.pagination-wrapper {
  position: fixed;
  bottom: 0;
  left: var(--layout-aside-width, 200px);
  right: 0;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  border-top: 1px solid #ebeef5;
  z-index: 100;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
}

/* 空状态优化 */
.el-empty__description {
  color: #909399;
}
</style>

